import { useEffect } from 'react';
import classNames from 'classnames';

import { disableBodyScroll, enableBodyScroll } from 'shared/util/bodyScroll';
import { Filters } from '../filters/Filters';
import type { Filters as FiltersType } from '@/domain';

type ResultFilterMapProps = {
    filtersOpen: boolean;
    filters: FiltersType;
    filterResults: (filters: FiltersType) => void;
    filterData: Record<string, unknown>;
};

export const ResultFilterMap = ({ filterData, filterResults, filters, filtersOpen }: ResultFilterMapProps) => {
    useEffect(() => {
        if (filtersOpen) {
            disableBodyScroll();
        } else {
            enableBodyScroll();
        }
    });

    return (
        <div className={classNames('filters-overlay-map map-view', { active: filtersOpen })}>
            <Filters onFilterChanged={filterResults} filterData={filterData} filters={filters} />
        </div>
    );
};
